module.exports = __webpack_public_path__ + "static/media/star-preto.7c18076d.webp";